import { ProductListFilters } from '@/api/ProductListsApi';
import { QueryClient } from '@tanstack/react-query';

export const productListQueryKeys = {
  all: ['productLists'] as const,
  lists: () => [...productListQueryKeys.all, 'list'] as const,
  list: (page: number, query?: string, filters?: ProductListFilters) =>
    [...productListQueryKeys.lists(), { page, query, filters }] as const,
  details: () => [...productListQueryKeys.all, 'detail'] as const,
  detail: (productListId?: string) => [...productListQueryKeys.details(), productListId] as const,
  skuIdsRoot: (productListId: string) =>
    [...productListQueryKeys.detail(productListId), 'skuIds'] as const,
  skuIds: (productListId: string, page: number) =>
    [...productListQueryKeys.skuIdsRoot(productListId), page] as const,
  retailerAssignmentsRoot: (productListId: string) =>
    [...productListQueryKeys.detail(productListId), 'retailerAssignments'] as const,
  retailerAssignments: (productListId: string, page: number) =>
    [...productListQueryKeys.retailerAssignmentsRoot(productListId), page] as const,
  retailerAssignmentOptions: (productListId: string) =>
    [...productListQueryKeys.details(), productListId, 'retailerAssignmentOptions'] as const,
  storeAssignmentsRoot: (productListId: string) =>
    [...productListQueryKeys.detail(productListId), 'storeAssignments'] as const,
  storeAssignments: (productListId: string, page: number) =>
    [...productListQueryKeys.storeAssignmentsRoot(productListId), page] as const,
  storeAssignmentOptions: (productListId: string) =>
    [...productListQueryKeys.details(), productListId, 'storeAssignmentOptions'] as const,
  portfolios: () => [...productListQueryKeys.all, 'portfolio'] as const,
  portfolio: (storeId?: string, supplierId?: string) =>
    [...productListQueryKeys.portfolios(), { storeId, supplierId }] as const,
};

export const invalidateProductListLists = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({ queryKey: productListQueryKeys.lists() });

export const invalidateProductListDetail = (queryClient: QueryClient, productListId: string) =>
  queryClient.invalidateQueries({ queryKey: productListQueryKeys.detail(productListId) });

export const invalidateProductListPortfolios = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({ queryKey: productListQueryKeys.portfolios() });
